<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: function (to, from) {
      localStorage.setItem("lastRouter", to.fullPath);
      localStorage.setItem("lastRouterName", to.name);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    isLogin(val, oldVal) {
      if (val) {
        this.$router.push({ path: "/main" });
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  methods: {
    getToken() {
      if (this.$route.path != "/") {
        if (localStorage.getItem("token")) {
        } else {
          this.api.user.getToken().then((res) => {
            if (res.data != this.user.Token) {
              this.$message.success("登录失效，请重新登录");
              this.logout();
            }
            localStorage.setItem("token", this.user.Token);
          });
        }
      }
    },
    logout() {
      this.$store.commit("signOut");
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    this.getToken();
    this.$store.dispatch("getAuthList");
    this.$store.dispatch("getCurrentUser");
    let lastRouter = localStorage.getItem("lastRouter");
    if (lastRouter == "/notFound") {
      this.$store.commit("signOut");
      this.$message.error("当前登录已过期，请重新登录！");
    } else {
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
};
</script>

<style>
html,
body,
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0px;
  background-color: rgb(246, 249, 250);
}
.el-popover {
  min-width: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue